// Externe Bibliotheken
import React, { Component } from 'react';

// Interne Module
import { convertDate, convertDateToGerman, convertPrice } from '@/_helper/mapper';
import _ from 'lodash';
import * as storage from '@/_helper/storage';
import { getShortWeekday } from '@/_helper/bookingDetailsHelper';

// Styles
import './travelFactsBooking.scss';

class TravelFactsBooking extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: storage.get('bookingData').data,
        };
    }

    getHotelDetails() {
        if (this.state != null) {
            const { data } = this.state;

            if (
                data !== null &&
                data.frontendParams.hotelDetails !== undefined &&
                data.frontendParams.hotelDetails[0] !== undefined
            ) {
                const hotelDetails = data.frontendParams.hotelDetails;

                return (
                    <div className="line hotel-details">
                        <div>
                            <span className="icon hotel"></span>
                        </div>
                        <div className="booking-info">
                            <div className="title">Hotel</div>
                            {hotelDetails.map((hotel, index) => {
                                const starsContainer = [];

                                for (var i = 0; i < hotel.category; i++) {
                                    starsContainer.push(
                                        <i className="material-icons" key={i}>
                                            star
                                        </i>
                                    );
                                }

                                return (
                                    <div className="details-info" key={index}>
                                        <div className="name flex">
                                            <div>{hotel.name}</div>
                                            <div className="category flex flex-middle" category={hotel.category}>
                                                {starsContainer}
                                            </div>
                                        </div>
                                        <div>{hotel.room}</div>
                                        <div>{hotel.meal}</div>
                                        <div>
                                            {convertDateToGerman(convertDate(hotel.checkIn), { weekday: 'short' })}.,{' '}
                                            {hotel.checkIn} -{' '}
                                            {convertDateToGerman(convertDate(hotel.checkOut), { weekday: 'short' })}.,{' '}
                                            {hotel.checkOut}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            }
        }
    }

    getFlightDetails() {
        if (this.state != null) {
            const { data } = this.state;

            if (
                data !== null &&
                data.frontendParams.flightDetails !== undefined &&
                data.frontendParams.flightDetails.inbound !== undefined &&
                data.frontendParams.flightDetails.outbound !== undefined
            ) {
                const flightDetailsOutbound = data.frontendParams.flightDetails.outbound;
                const flightDetailsInbound = data.frontendParams.flightDetails.inbound;

                return (
                    <div className="line box flight-details">
                        <div>
                            <span className="icon flight"></span>
                        </div>
                        <div className="booking-info">
                            <div className="title">Flug</div>
                            <div className="details-info">
                                {flightDetailsOutbound.map((flight, index) => {
                                    return (
                                        <div key={index}>
                                            <div>
                                                {flight.depAirportDescription} ({flight.depAirportCode}) -{' '}
                                                {flight.arrAirportDescription} ({flight.arrAirportCode}) -{' '}
                                                {flight.carrier}
                                                {flight.flightNumber}
                                            </div>
                                            <div>
                                                {convertDateToGerman(convertDate(flight.depDate), { weekday: 'short' })}
                                                ., {flight.depDate} - {flight.depTime} Uhr
                                            </div>
                                        </div>
                                    );
                                })}

                                {flightDetailsInbound.map((flight, index) => {
                                    return (
                                        <div key={index}>
                                            <div>
                                                {flight.depAirportDescription} ({flight.depAirportCode}) -{' '}
                                                {flight.arrAirportDescription} ({flight.arrAirportCode}) -{' '}
                                                {flight.carrier}
                                                {flight.flightNumber}
                                            </div>
                                            <div>
                                                {convertDateToGerman(convertDate(flight.depDate), { weekday: 'short' })}
                                                ., {flight.depDate} - {flight.depTime} Uhr
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    getTransferDetails() {
        if (this.state != null) {
            const { data } = this.state;

            if (data !== null && data.frontendParams.transferDetails !== undefined) {
                const transferDetails = data.frontendParams.transferDetails;

                return (
                    <div className="line transfer-details">
                        <div>
                            <span className="icon transfer"></span>
                        </div>
                        <div className="booking-info">
                            <div className="title">Transfer</div>
                            <div className="details-info">
                                {window.$content.mappingTransfer[transferDetails?.tariff.toLowerCase()]
                                    ?.short_description !== undefined &&
                                    window.$content.mappingTransfer[transferDetails?.tariff.toLowerCase()]
                                        ?.short_description}
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    getExcursionDetails() {
        if (this.state != null) {
            const { data } = this.state;

            if (
                data !== null &&
                data.frontendParams?.excursions &&
                Object.keys(data.frontendParams.excursions).length > 0
            ) {
                const excursionDetails = data.frontendParams?.excursions;

                const activeExcursions = _.filter(excursionDetails, function (o) {
                    return o.state === 'OK';
                });
                const inactiveExcursions = _.filter(excursionDetails, function (o) {
                    return o.state !== 'OK';
                });

                return (
                    <div className="line excursion-details">
                        <div>
                            <span className="icon excursion"></span>
                        </div>
                        <div className="booking-info">
                            <div className="title">Ausflug</div>
                            <div className="details-info">
                                {activeExcursions.length >= 1 && (
                                    <div className="active">
                                        {activeExcursions.map((value, index) => {
                                            let parts = value.description.split(' - ');
                                            return (
                                                <div key={`excursion-active-${index}`}>
                                                    {index > 0 && <hr />}
                                                    <div className="e">
                                                        <div className="item">
                                                            <div>{parts[0]}</div>
                                                            <div>{parts[1]}</div>
                                                        </div>
                                                        <div className="item">
                                                            <div>
                                                                {getShortWeekday(value.startDate) +
                                                                    '., ' +
                                                                    value.startDate}
                                                            </div>
                                                            <div>
                                                                {value.participants.length &&
                                                                    value.participants.length + ' Pers.'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                                {inactiveExcursions.length >= 1 && (
                                    <div className="inactive">
                                        <hr />
                                        {inactiveExcursions.map((value, index) => {
                                            let parts = value.description.split(' - ');
                                            return (
                                                <div key={`excursion-inactive-${index}`}>
                                                    {index > 0 && <hr />}
                                                    <div>
                                                        <span className="chip storno"></span>
                                                    </div>
                                                    <div className="e">
                                                        <div className="item">
                                                            <div>{parts[0]}</div>
                                                            <div>{parts[1]}</div>
                                                        </div>
                                                        <div className="item">
                                                            <div>
                                                                {getShortWeekday(value.startDate) +
                                                                    '., ' +
                                                                    value.startDate}
                                                            </div>
                                                            <div>
                                                                {value.participants.length &&
                                                                    value.participants.length + ' Pers.'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    getPriceDetails() {
        if (this.state != null) {
            const { data } = this.state;

            if (data !== null && data?.frontendParams.price.total !== undefined) {
                return (
                    <div className="price-sec">
                        {convertPrice(data.frontendParams.price.total, 0, 0)}
                        <div className="price-small-print">(Gesamtpreis für alle Reisenden)</div>
                    </div>
                );
            }
        }
    }

    render() {
        return (
            <div className={'sec travel-facts-booking'} key={''}>
                <div className="intro-line">
                    <div className="summary-headline">Flug + Hotel</div>
                    <div
                        className="trigger"
                        onClick={(e) =>
                            e.target.closest('.sec').classList.contains('active')
                                ? ((e.target.innerHTML = 'mehr Details'),
                                  e.target.closest('.sec').classList.remove('active'))
                                : ((e.target.innerHTML = 'weniger Details'),
                                  e.target.closest('.sec').classList.add('active'))
                        }>
                        mehr Details
                    </div>
                </div>

                <div className="content">
                    <div className="col inline">
                        <div className="main">
                            {this.getHotelDetails()}

                            {this.getFlightDetails()}

                            {this.getTransferDetails()}

                            {this.getExcursionDetails()}
                        </div>

                        {this.getPriceDetails()}
                    </div>
                </div>
            </div>
        );
    }
}

export default TravelFactsBooking;
